<template>
    <div>
        <q-submenu :title="title" :titlelink="titlelink" :buttons="buttons" :submenu="submenu" class="q-sticky"></q-submenu>
    </div>
</template>
<script>
//table data + search
import QSubmenu from '@/components/navigation/Submenus/QSubmenu.vue'

export default {
    data() {
        return {
            title: 'Admin',
            titlelink: null,
        }
    },
    mounted: function() {
        this.maybeAutoStartDemo('DemoAgency')
    },
    computed: {
        submenu: function() {
            var g = this
            return []
            /*if (this.hasRole(['Staff', 'ContentEditor', 'Exec', 'SuperAdmin'])) {
                return [{
                    label: "Help",
                    to: "/page/frequently-asked-questions"
                }, {
                    label: "Weekly Onboarding Report",
                    to: "/admin/reports/onboarding_report"
                }]
            } else {
                return [{
                    label: "Help",
                    to: "/page/frequently-asked-questions"
                }]
            }*/
        },
        buttons () {
            return [(this.hasRole('SuperAdmin') && {
                    label: 'Manage Staff Accounts',
                    to: '/admin/tenantstaff',
                    icon: 'fas fa-arrow-alt-circle-right',
                    id: '',
                }),
                {
                    label: 'Agent Directory',
                    to: '/admin/agency-building/directory',
                    icon: 'fas fa-arrow-alt-circle-right',
                    id: 'v-owner-agent-directory',
                },
                (this.hasRole('SuperAdmin') && {
                    label: 'New Agent',
                    to: '/admin/agents/new_agent',
                    icon: 'fas fa-arrow-alt-circle-right',
                    id: 'v-new-agent',
                }),
                {
                    label: 'Agency Structure',
                    to: '/admin/agency-building/structure',
                    icon: 'fas fa-arrow-alt-circle-right',
                    id: 'v-owner-structure',
                },
                (this.hasRole('SuperAdmin') && {
                    label: 'HQ Stats',
                    to: '/admin/my_stats/scorecard/hq',
                    icon: 'fas fa-arrow-alt-circle-right',
                    id: '',
                }),
                (this.tenantHasFeature('DTCWidget') && {
                    label: 'Affiliate DTC Widget',
                    to: '/admin/AffiliateWidget',
                    icon: 'fas fa-arrow-alt-circle-right',
                    id: '',
                }),
            ].filter(Boolean)
        },
    },
    components: {
        QSubmenu,
    },
    methods: {
        startDemo() {
            this.$tours['DemoAgency'].start()
        }
    },
}
</script>
